<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div class="mainBody">
            <div class="searchBox">
                <div class="searchGroup">
                    <label>姓名：</label>
                    <el-input v-model="search_Obj.f_user_name" clearable @keyup.enter.native="doSearch"></el-input>
                </div>
                <div class="searchGroup">
                        <label>发送状态：</label>
                        <el-select v-model="search_Obj.f_send_state" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('send_state')" :key="'sendstate'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                <el-button type="primary"  @click="addUser">添加</el-button>
                <el-button type="danger"  @click="delAll">删除</el-button>
                <el-button type="primary"  @click="send">执行公众号推送</el-button>
            </div>
            <div class="dataBox">
                <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                    <el-table-column type="selection" align="center" width="50"></el-table-column>
                    <el-table-column prop="user_name" label="用户姓名" sortable="custom"></el-table-column>
                    <el-table-column prop="org_name" label="所在机构" sortable="custom"></el-table-column>
                    <el-table-column prop="send_state" label="发送状态" sortable="custom">
                        <template slot-scope="scope">
                            <span>{{ transEnu(scope.row.send_state, "send_state") }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="fail_reason" label="发送失败原因" sortable="custom"></el-table-column>
                    <el-table-column prop="send_time" label="发送时间" sortable="custom"></el-table-column>
                </el-table>
            </div>
            <div class="pageBox">
                <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
            </div>
        </div>
        <UserSelect
            width="1200px"
            title="选择用户"
            :isshow="show_user_list"
            @setUser="setUser"
            @on-close="closeSelDialog">
        </UserSelect>
    </el-dialog>
</template>

<script>
import listutil from "@/libs/listutil"
import { addDayReportUser, sendDayReportUser } from '@/api/dayreport'
import UserSelect from "../user/userselect"

export default {
    name: 'dayReportUserList',
    mixins: [listutil],
    components: {UserSelect},
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        id: {
            type: Number,
            default() {
                return -1;
            }
        },
        title: {
            type: String,
            default() {
                return ""
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            this.search_Obj.f_day_report_id = this.id;
            this.getData()
        },
    },
    data() {
        return {
            m_name: '日常快报推送用户',
            menu_id: 9999,
            list_url: "/api/admin/dayreportuser/list",
            search_Obj: {
                f_day_report_id: '',
                f_user_name: '',
                f_send_state: '',
            },
            del_Obj:{
                url:'/api/admin/dayreportuser/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['send_state'],
            showflag: false,
            show_user_list: false,
            user_ids: '',
        };
    },
    methods: {
        closeDialog() {
            this.$emit("on-close")
        },
        addUser(){
            this.show_user_list = true
        },
        setUser(user_ids){
            this.user_ids = user_ids
            addDayReportUser(this.search_Obj.f_day_report_id, this.user_ids).then(res=>{
                if (res.code == 1) {
                    this.$msgs(res.msg)
                } else {
                    this.$msg(res.msg)
                }
                this.closeSelDialog()
            })
        },
        closeSelDialog(){
            this.show_user_list = false
            this.getListData()
        },
        send(){
            sendDayReportUser(this.search_Obj.f_day_report_id).then(res=>{
                if (res.code == 1) {
                    this.$msgs("执行完成")
                    this.getListData();
                } else {
                    this.$msg(res.msg)
                }
            })
        },
    }
};
</script>